<div class="splash-content" @splashAnimate>
   <img src="assets/images/Stonelogo.png" alt="Stonwerk">
</div>